import { useState } from "react";
import { Popover } from "antd";
import { Trans } from "react-i18next";
import PopoverLanguageContent from "./LanguageContent";
import classNames from "classnames";
import { IconArrowDown, IconLanguage2 } from "@icons/index";

interface LanguagePopoverProps {
  /** 当前语言标签 */
  currentLanguageLabel: string;
  /** 关闭回调函数 */
  onClose?: () => void;
  /** Popover 对齐偏移量 [x, y] */
  offset?: [number, number];
  /** Popover 位置 */
  placement?: "leftBottom" | "left" | "bottom" | "top" | "right";
}

export default function LanguagePopover({
  currentLanguageLabel,
  onClose,
  offset = [-8, 75],
  placement = "leftBottom",
}: LanguagePopoverProps) {
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
    onClose?.();
  };

  return (
    <Popover
      content={
        <div onMouseLeave={() => setOpen(false)}>
          <PopoverLanguageContent onClick={handleClose}></PopoverLanguageContent>
        </div>
      }
      placement={placement}
      arrow={false}
      align={{ offset }}
      open={open}
      onOpenChange={setOpen}
      trigger="hover"
    >
      <div
        className={classNames(
          "flex items-center justify-between gap-[6px] h-[36px] p-[8px] rounded-[8px] cursor-pointer hover:bg-kds-bg-overlay",
          open && "bg-kds-bg-overlay",
        )}
      >
        <div className="flex items-center gap-[6px]">
          <IconLanguage2 className="w-[16px] h-[16px]" />
          <span className="text-kds-fg text-[14px] font-normal">
            <Trans i18nKey="user_language">Language</Trans>
          </span>
        </div>
        <div className="flex items-center gap-[4px]">
          <span className="text-[12px] text-kds-fg-subtle">{currentLanguageLabel}</span>
          <IconArrowDown className="w-[16px] h-[16px] -rotate-90 text-kds-fg-subtle" />
        </div>
      </div>
    </Popover>
  );
}
